import { render, staticRenderFns } from "./ReservesList.vue?vue&type=template&id=988b40a4&scoped=true&"
import script from "./ReservesList.vue?vue&type=script&lang=js&"
export * from "./ReservesList.vue?vue&type=script&lang=js&"
import style0 from "./ReservesList.vue?vue&type=style&index=0&id=988b40a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988b40a4",
  null
  
)

export default component.exports